var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dividends-tab" }, [
    _c("div", { staticClass: "dividends-tab__content" }, [
      _c("div", { staticClass: "dividends-tab__title" }, [
        _vm._v(
          _vm._s(
            _vm.isDocumentsUploaded
              ? _vm.i18n.divid_ready_to_pay()
              : _vm.i18n.divid_tab_finish_title()
          )
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "dividends-tab__text_wrap" }, [
        !_vm.isDocumentsUploaded
          ? _c("div", { staticClass: "dividends-tab__text" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.i18n.lbl_go_to_section()) +
                  "\n        "
              ),
              _c(
                "span",
                {
                  staticClass: "dividends-tab__docs-link",
                  on: { click: _vm.goToDocuments }
                },
                [_vm._v(_vm._s(_vm.i18n.lbl_documents()))]
              ),
              _vm._v(
                "\n        " +
                  _vm._s(_vm.i18n.divid_tab_finish_text()) +
                  "\n      "
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.isDocumentsUploaded
        ? _c(
            "div",
            { staticClass: "btn-wrap" },
            [
              _c(
                "md-button",
                {
                  staticClass: "btn md-primary",
                  on: {
                    click: function($event) {
                      return _vm.showDividends()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.i18n.lbl_go_to_pay()))]
              )
            ],
            1
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ca76371c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca76371c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/sales/sale_details/tabs/Sales.DividendsTab.vue
// module id = ag6n
// module chunks = 1